export const isMobileApp = () => process.env.REACT_APP_ENTRY === 'maquinista';
